<template>
  <div class="row">
    <div class="col-3">
      <div class="input-group">
        <span class="input-group-text">Postal Code:</span>
        <input v-model="postalCode" type="text" class="form-control" @keyup.enter="addPostalCode" />
        <button class="btn btn-primary btn-sm" @click="addPostalCode">
          <FontAwesomeIcon icon="fa-solid fa-plus" />
        </button>
      </div>
    </div>
    <div class="col">
      <Pills :items="postalCodes" :customClass="'bg-success'" @remove="deletePostalCode" />
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { locationStore } from '@/stores/location'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Pills from '@/components/utilities/elements/Pills.vue'
export default {
  name: 'LocationServiceArea',
  components: {
    FontAwesomeIcon,
    Pills
  },
  data() {
    return {
      postalCode: ''
    }
  },
  emits: ['changed'],
  computed: {
    ...mapState(locationStore, ['postalCodes'])
  },
  methods: {
    ...mapActions(locationStore, ['resetPostalCodes', 'setPostalCode', 'removePostalCode']),
    addPostalCode() {
      if (this.postalCode) {
        if (this.postalCode.trim() !== '') {
          if (this.postalCode.indexOf(',') !== -1) {
            let codes = this.postalCode.split(',')
            codes.forEach((code) => {
              this.setPostalCode(code.trim())
            })
          } else {
            this.setPostalCode(this.postalCode.trim())
          }
          this.postalCode = ''
        }
      }
      this.$emit('changed')
    },
    deletePostalCode(data) {
      this.removePostalCode(data)
      this.$emit('changed')
    }
  }
}
</script>
<style lang="scss" scoped></style>
